const Tagline = () => {
    return (
        <div class="w-[40%]">
            <p className="text-5xl font-light leading-[1.3] primary">
                <span >"New Revolutionary</span><br />
                <span className="text-[#53B649] font-semibold">Smart Trading</span>
                <span > for a<br />Global Market Edge"</span>
            </p>
        </div>
    )
}

export default Tagline